import React from 'react';
import styled, { css } from 'styled-components';

import QuoteLeftIcon from '@/assets/svg/quote-left.svg';
import QuoteRightIcon from '@/assets/svg/quote-right.svg';
import { media } from '@/utils/mixin';

interface Props {
  text: string;
  author?: {
    name: string;
    position: string;
  };
}

function BlockQuote({ text, author }: Props) {
  return (
    <Component>
      <Figure>
        <FigureLeftIcon>
          <QuoteLeftIcon />
        </FigureLeftIcon>

        <FigureContainer>
          <Quote>{text}</Quote>
          {author && (
            <Figcaption>
              <AuthorName>{author.name}</AuthorName>
              <AuthorDescription>{author.position}</AuthorDescription>
            </Figcaption>
          )}
        </FigureContainer>

        <FigureRightIcon>
          <QuoteRightIcon />
        </FigureRightIcon>
      </Figure>
    </Component>
  );
}

export default BlockQuote;

const Component = styled.div`
  margin: 36px auto;
  padding: 0 20px;
  width: 100%;
  max-width: 67%;

  ${media.tablet(css`
    max-width: 100%;
  `)};

  @media (min-width: 1400px) {
    margin: 58px auto;
  }
`;

const Figure = styled.figure`
  position: relative;
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100% !important;
  background: ${(props) => props.theme.gray100};
`;

const FigureContainer = styled.div`
  padding: 36px 10px;

  @media (min-width: 1400px) {
    padding: 70px 10px;
  }
`;

const Quote = styled.blockquote`
  max-width: 752px;
  margin: 0 auto;

  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  text-align: center;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 28px;
  }
`;

const Figcaption = styled.figcaption`
  margin-top: 20px;
  text-align: center;
`;

const AuthorName = styled.div`
  margin-top: 10px;
  margin-bottom: 5px;

  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: ${(props) => props.theme.black100};
  opacity: 0.5;

  @media (min-width: 1400px) {
    margin-top: 20px;
  }
`;

const AuthorDescription = styled.div`
  margin-top: 5px;

  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  text-align: center;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    font-size: 22px;
  }
`;

const FigureLeftIcon = styled.span`
  position: absolute;
  top: -17px;
  left: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 30px;
    height: 33px;
  }

  @media (min-width: 1400px) {
    left: 65px;

    svg {
      width: 51px;
      height: 55px;
    }
  }
`;

const FigureRightIcon = styled.span`
  position: absolute;
  right: 20px;
  bottom: -17px;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 30px;
    height: 33px;
  }

  @media (min-width: 1400px) {
    right: 65px;

    svg {
      width: 51px;
      height: 55px;
    }
  }
`;
